import React from "react";

const arrivalDeclarationRoutes = [
    {
        path: "/applications/arrivalDeclaration/list",
        component: React.lazy(() =>
            import("./ArrivalDeclarationList")
        ),
    },
    {
        path: "/applications/arrivalDeclaration/:viewType/:appId",
        component: React.lazy(() => import("./ArrivalDeclarationDetails"))
    },
];

export default arrivalDeclarationRoutes;